export const MODAL_INFO_OPEN = "MODAL_INFO_OPEN";
export const MODAL_DELETE_OPEN = "MODAL_DELETE_OPEN";
export const MODAL_UPLOAD_OPEN = "MODAL_UPLOAD_OPEN";
export const MODAL_CLOSE = "MODAL_CLOSE";
export const DELETE_MODAL_CLOSE = "DELETE_MODAL_CLOSE";
export const UPLOAD_MODAL_CLOSE = "UPLOAD_MODAL_CLOSE";

export const MODAL_CONFIRM_OPEN = "MODAL_CONFIRM_OPEN";
export const MODAL_CONFIRM_CLOSE = "MODAL_CONFIRM_CLOSE";
